import useGlobalMethods from '@hooks/use-global-methods';
export var GlobalMethods = function () {
    useGlobalMethods();
    return null;
};
export default GlobalMethods;
